import { fetcher } from '@commenda/utils';
import { CommendaService, CreateCommendaServicePayload } from './types';

export const createCommendaService = async (
  data: CreateCommendaServicePayload
): Promise<{
  success: boolean;
  data?: CommendaService;
  error?: string;
  status?: number;
}> => {
  try {
    const res = await fetcher('commenda-services', {
      method: 'POST',
      body: data,
    });
    if (!res.ok) {
      const errorBody = (await res.json()) as { message?: string } | null;
      return { success: false, error: errorBody?.message, status: res.status };
    }
    const service = (await res.json()) as CommendaService;
    return { success: true, data: service };
  } catch (err) {
    console.error(err);
    return { success: false };
  }
};
